import React from 'react';
import { createRoot } from 'react-dom/client';

// new Builders
import DesktopPrintsBuilder from '../customer_pages/_prints-builder/desktop';
import MobilePrintsBuilder from '../customer_pages/_prints-builder/mobile';

import 'Utils/login-launcher';
import '../customer_pages/_prints-builder/common/debounced-scroll-handler';
import '../customer_pages/_application/iframe-login';
import '../customer_pages/_application/menu-analytics';

const isDebugEnabled = document.cookie.includes('pb_debug='); // Enable debug tools if 'pb_debug' cookie (any value) is present

if (bootstrapSize.isBootstrapXS() || bootstrapSize.isBootstrapSM()) {
  // Render Mobile Prints Builder

  // The following components are broken with StrictMode -- will have to fix them first and then re-enable
  // AdvancedEditor, PricingChartPopup
  createRoot(document.getElementById('content')).render(
    // <StrictMode>
    <MobilePrintsBuilder
      urls={window.urls}
      features={{
        ...window.features,
        mobile: true,
        debugEnabled: isDebugEnabled,
      }}
      uploadFromGalleryListenerUrl={window.uploadFromGalleryListenerUrl}
      initSessionTimeout={window.initSessionTimeout}
    />,
    // </StrictMode>,
  );
} else {
  // Render Desktop Prints Builder

  // The following components are broken with StrictMode -- will have to fix them first and then re-enable
  // AdvancedEditor, PricingChartPopup
  createRoot(document.getElementById('content')).render(
    // <StrictMode>
    <DesktopPrintsBuilder
      urls={window.urls}
      features={{
        ...window.features,
        mobile: false,
        debugEnabled: isDebugEnabled,
      }}
      uploadFromGalleryListenerUrl={window.uploadFromGalleryListenerUrl}
    />,
    // </StrictMode>,
  );
}
